// removed by extract-text-webpack-plugin
module.exports = {"field":"theme__field__12sVbsqV","text":"theme__text__kjPX71YX","thumb":"theme__thumb__-mqZJwsR","ripple":"theme__ripple__2GhftaBA","off":"theme__off__zBwyQD39","on":"theme__on__1-Ls9Lo_","input":"theme__input__185cGqXW","switch-off":"theme__switch-off__2rQA1BoF","switch-on":"theme__switch-on__XCpWVSnp","disabled":"theme__disabled__rjC6-Xrv theme__field__12sVbsqV"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-toolbox/lib/switch/theme.css
// module id = 1395
// module chunks = 0